<main id="main-content" class="ds-product-page practice-page">
  <header class="practice-hero">
    <p class="ds-eyebrow">Reasoning gym</p>
    <h1>Daily challenge and practice mode</h1>
    <p>
      Build familiarity with reasoning formats using educational puzzles that are separate from the
      scored assessment bank.
    </p>
  </header>
  <nav class="mode-tabs" aria-label="Practice mode">
    <button
      dsButton
      [variant]="mode() === 'daily' ? 'primary' : 'secondary'"
      type="button"
      (click)="setMode('daily')"
    >
      Daily challenge
    </button>
    <button
      dsButton
      [variant]="mode() === 'practice' ? 'primary' : 'secondary'"
      type="button"
      (click)="setMode('practice')"
    >
      Free practice
    </button>
  </nav>
  @if (mode() === 'practice') {
    <div class="domain-filter" role="group" aria-label="Reasoning domain">
      @for (item of ['All', 'Abstract', 'Numerical', 'Verbal', 'Spatial']; track item) {
        <button type="button" [class.active]="domain() === item" (click)="setDomain($any(item))">
          {{ item }}
        </button>
      }
    </div>
  }
  <section dsCard class="puzzle-card" aria-labelledby="puzzle-title">
    <header>
      <ds-badge>{{ puzzle().domain }}</ds-badge
      ><span>{{
        mode() === 'daily' ? 'One new puzzle each day' : 'Practice question ' + (index() + 1)
      }}</span>
    </header>
    <h2 id="puzzle-title">{{ puzzle().prompt }}</h2>
    <div class="puzzle-options">
      @for (option of puzzle().options; track option; let optionIndex = $index) {
        <button
          type="button"
          [disabled]="selected() !== null"
          [class.chosen]="selected() === optionIndex"
          [class.correct]="selected() !== null && puzzle().answer === optionIndex"
          (click)="choose(optionIndex)"
        >
          <span>{{ ['A', 'B', 'C', 'D'][optionIndex] }}</span
          >{{ option }}
        </button>
      }
    </div>
    @if (selected() !== null) {
      <div class="explanation" aria-live="polite">
        <strong>{{ selected() === puzzle().answer ? 'Correct' : 'Not quite' }}</strong>
        <p>{{ puzzle().explanation }}</p>
      </div>
      @if (mode() === 'practice') {
        <button dsButton type="button" (click)="next()">Next practice question</button>
      }
    }
  </section>
  @if (mode() === 'practice' && attempted()) {
    <section dsCard class="session-progress">
      <div>
        <strong>{{ correct() }}/{{ attempted() }}</strong
        ><span>correct this session</span>
      </div>
      <ds-progress [value]="(correct() / attempted()) * 100" label="Practice accuracy" />
    </section>
  }
  <p class="practice-note">
    Practice performance is not added to your IQ-style result. Explanations are provided for
    learning, not memorizing scored answers.
  </p>
</main>
